export default class ComparatorCards {

    constructor($view) {
        this.$view = $view;
        this.$cards = this.$view.find('.catalog-card');
        this.bind()
    }

    bind() {
        for (let card of this.$cards) {
            $(card).on('mouseover', () => {
                card.style.opacity = 1;
                card.style.transform = 'scale(1.02)';

                for (let otherCard of this.$cards) {
                    if (otherCard !== card) {
                        otherCard.style.opacity = 0.5;
                    }
                }
            })
            $(card).on('mouseleave', () => {
                for (let otherCard of this.$cards) {
                    otherCard.style.opacity = null;
                }
            })
        }
    }
}